import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import type { ReceivedImagePayload } from '../../../types';
import useIdDocMachine from '../../hooks/use-id-doc-machine';
import SelfiePhotoView from './selfie-photo-view';
const SelfiePhoto = () => {
  const $ = _c(17);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "document-flow.id-doc.pages.selfie-photo"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t0);
  const [state, dispatch] = useIdDocMachine();
  const {
    requirement,
    hasBadConnectivity,
    allowPdf
  } = state.context;
  let t1;
  if ($[1] !== dispatch) {
    t1 = payload => dispatch({
      type: "receivedImage",
      payload
    });
    $[1] = dispatch;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const onComplete = t1;
  let t2;
  if ($[3] !== dispatch) {
    t2 = () => dispatch({
      type: "navigatedToPrev"
    });
    $[3] = dispatch;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleClickBack = t2;
  let t3;
  if ($[5] !== dispatch) {
    t3 = () => dispatch({
      type: "cameraStuck"
    });
    $[5] = dispatch;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const handleCameraStuck = t3;
  let t4;
  if ($[7] !== t) {
    t4 = t(_temp);
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== allowPdf || $[10] !== handleCameraStuck || $[11] !== handleClickBack || $[12] !== hasBadConnectivity || $[13] !== onComplete || $[14] !== requirement || $[15] !== t4) {
    t5 = <SelfiePhotoView title={t4} requirement={requirement} hasBadConnectivity={hasBadConnectivity} allowPdf={allowPdf} onComplete={onComplete} onBack={handleClickBack} onCameraStuck={handleCameraStuck} />;
    $[9] = allowPdf;
    $[10] = handleCameraStuck;
    $[11] = handleClickBack;
    $[12] = hasBadConnectivity;
    $[13] = onComplete;
    $[14] = requirement;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
};
export default SelfiePhoto;
function _temp($) {
  return $.title;
}